import React from 'react'

const SportsBetting = () => {
  return (
    <div>SportsBetting</div>
  )
}

export default SportsBetting